module.exports = __webpack_public_path__ + "img/1.899a426a.jpg";